<template>
	<div class="receipt">
		<div class="row receipt-header">
			<div class="col-xs-8">
				<h1 class="title">{{ receipt.number }}</h1>
				<b>{{this.setting.company ? this.setting.company.name : ""}}</b>
				<p>{{this.setting.company ? this.setting.company.address : "" }}<br />
				<a v-bind:href="'mailto:/' + (this.setting.company ? this.setting.company.email : '')">{{this.setting.company ? this.setting.company.email : ""}}</a>
				<a v-bind:href="'tel:/' + (this.setting.company ? this.setting.company.phone : '')">{{this.setting.company ? this.setting.company.phone : ""}}</a> <br />
				</p>
			</div>
			<div class="col-xs-4">
				<span :style="styleObject" class="header-logo-print"></span>
			</div>
		</div>
		<div class="row receipt-body">
			<div class="col-xs-12">
				<table class="table table-bordered receipt-detail">
					<tbody>
						<tr>
							<th>Amount Received</th>
							<td>{{ formatPrice(receipt.amount) }}</td>
						</tr>
						<tr>
							<th>Date Received</th>
							<td>{{ receipt.date }}</td>
						</tr>
						<tr>
							<th>Received From</th>
							<td><span v-html="companyInfo" /> <br /><br /> <span v-html="companyContact"/></td>
						</tr>
						<tr>
							<th>Note</th>
							<td>{{ receipt.note }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { formatPrice } from '../../helpers';
export default {
	props: {
		receipt: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			isLoading: false,
			setting: { company: null },
			styleObject: ""
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			const settingResp = await axios.get(`/settings`);
			this.setting = settingResp.data.data;
			this.styleObject = {
				background: `#FFF scroll 0% 0%`,
				backgroundRepeat: 'no-repeat !important',
				backgroundImage: 'url(' + this.setting.company.logo + ') !important',
				backgroundSize: 'contain'
			};
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
	computed: {
		companyInfo() {
			return this.receipt.invoice ? this.receipt.invoice.customer.name + '<br />' + this.receipt.invoice.customer.company.name + '<br />' 
						+ (this.receipt.invoice.customer.company.address ? this.receipt.invoice.customer.company.address : "") + '' : "";
		},
		companyContact() {
			return this.receipt.invoice ? (this.receipt.invoice.customer.phone ? this.receipt.invoice.customer.phone : "") + '<br />' + (this.receipt.invoice.customer.email ? this.receipt.invoice.customer.email : "") : "";
		},
	},
	methods: {
		formatPrice,
	}
}
</script>